import { WidgetWrapper } from "./WidgetWrapper"
import * as HomeEvents from "@/analytics/events/home"
import { Body, H3 } from "@/components/standard/BFText"
import { View } from "react-native"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { persistentAtom } from "@nanostores/persistent"
import { useStore } from "@nanostores/react"
import useDeviceAttributes from "@/hooks/useDeviceAttributes"
import { PlayStoreDownloadButton } from "@/components/buttons/PlayStoreDownloadButton"
import { AppleStoreDownloadButton } from "@/components/buttons/AppleStoreDownloadButton"
import { BFCloseButton } from "@/components/standard/BFCloseButton"

// Create a persistent store to remember if user has dismissed the widget
export const $appDownloadHomeWidget = persistentAtom<"true" | "false">(
  "appDownloadHomeWidget",
  "true"
)

export default function AppDownloadWidget() {
  const { isIos, isAndroid, isWeb } = useDeviceAttributes()
  const shouldShow = useStore($appDownloadHomeWidget)

  // Don't show widget on native platforms or if user dismissed it
  if (!isWeb || isIos || isAndroid || shouldShow === "false") {
    return null
  }

  const onPress = () => {
    // Track widget click event
    HomeEvents.homepageWidgetClicked({
      widgetType: "widget-appdownload",
      nextScreen: "Home",
      widgetTitle: "Download App",
      widgetCta: "Download our native app today",
    })
  }

  const handleDismiss = () => {
    $appDownloadHomeWidget.set("false")
  }

  const handleAppleDownload = () => {
    onPress()
    // Add your analytics event here if needed
  }

  const handleGoogleDownload = () => {
    onPress()
    // Add your analytics event here if needed
  }

  return (
    <WidgetWrapper
      category="marketing"
      orientation="horizontal"
      title="Download App"
      // Making the widget wrapper not clickable by setting onPress to undefined
      onPress={undefined}
    >
      <Vertical className="w-full items-center p-5 bg-beige overflow-hidden rounded-md">
        {/* Close button positioned absolutely in top right corner */}
        <View className="absolute top-3 right-3 size-4 z-10">
          <BFCloseButton dark={true} onPress={handleDismiss} />
        </View>

        {/* Main content */}
        <Vertical className="w-full gap-4">
          <H3 color="primary">Don’t Miss Out</H3>
          <Body color="primary">
            Track your loan, analyze deals instantly, and unlock app-only tools.
            Download the app to get the full experience.
          </Body>

          {/* Download buttons container */}
          <Horizontal className="justify-between items-center gap-4 mt-1">
            <AppleStoreDownloadButton
              width={135}
              height={40}
              onPress={handleAppleDownload}
            />
            <PlayStoreDownloadButton
              width={135}
              height={40}
              onPress={handleGoogleDownload}
              className="mt-[-13px]" // Adjustment to align with Apple button
            />
          </Horizontal>
        </Vertical>
      </Vertical>
    </WidgetWrapper>
  )
}
